const concat = (list: unknown[]) => Array.prototype.concat.bind(list);
const promiseConcat = (f: () => Promise<unknown>) => (x: unknown[]) =>
  f().then(concat(x)).catch((err) => console.log(err, 'err'));
const promiseReduce = (acc: Promise<unknown[]>, x: () => Promise<unknown>) =>
  acc.then(promiseConcat(x)).catch((err) => console.log(err, 'err'));

export const serializeFuncs = (funcs: Array<() => Promise<unknown>>) =>
  funcs.reduce(promiseReduce, Promise.resolve([]));
